import { useEffect, useState } from "react";

const getViewports = () => ({
    visualViewport: {
        width: window.visualViewport
            ? window.visualViewport.width
            : window.innerWidth,
        height: window.visualViewport
            ? window.visualViewport.height
            : window.innerHeight,
    },
    windowSize: {
        width: window.innerWidth,
        height: window.innerHeight,
    },
});

const useVisualViewport = () => {
    const [size, setSize] = useState(getViewports);

    const handleResize = () => setSize(getViewports);

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        if (window.visualViewport)
            window.visualViewport.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            if (window.visualViewport)
                window.visualViewport.removeEventListener(
                    "resize",
                    handleResize
                );
        };
    }, []);

    return size;
};

export default useVisualViewport;
